import { giftTitle } from "../../configuration";

const CURRENCY = "JPY";

export interface IDataLayerItem {
  item_id: string;
  item_name: string;
  price: number;
  quantity: number;
}

const getDataLayer = (): any[] => {
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  return w.dataLayer;
};

export const gtm = {
  push(payload: Record<string, any>) {
    getDataLayer().push(payload);
  },
  pushEcommerce(event: string, items: IDataLayerItem[]) {
    const value = items.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );
    getDataLayer().push({ ecommerce: null });
    getDataLayer().push({
      event,
      ecommerce: { currency: CURRENCY, value, items },
    });
  },
};


export const toDataLayerItem = (book: any): IDataLayerItem => ({
  item_id: `${book?.book_id ?? book?.id ?? ""}`,
  item_name: book?.is_gift ? giftTitle : book?.book_name ?? "",
  price: Number(book?.price) || 0,
  quantity: Number(book?.amount) || 1,
});
